<template>
  <div v-if="data" class="d-flex align-center" style="position: relative">
    <!-- 비동기 업로드 중 -->
    <div v-if="data?.is_processing" class="d-flex align-center justify-center" :style="{width: iconWidth, height: iconHeight}">
      <!-- <img src="/assets/loading.svg" style="width: 20px; height: 20px"> -->
      <v-progress-circular 
        :size="20" :width="2" color="#D8DAE9" indeterminate
      ></v-progress-circular>
    </div>
    <!-- file 존재 -->
    <div v-else-if="data?.file" class="d-flex align-center">
      <!-- Re:D -->
      <img v-if="data?.category === 'common' && (data?.file.includes('xls') || data?.file.includes('csv'))"
        src="/assets/data_icon/icon_recolumn2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- master -->
      <img v-else-if="data?.category === 'master'"
        src="/assets/data_icon/icon_master.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Excel -->
      <img v-else-if="data?.file.includes('xls') || data?.file.includes('csv')"
        src="/assets/data_icon/icon_excel.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Image -->
      <img v-else-if="data?.file.includes('jpg') || data?.file.includes('jpeg') || data?.file.includes('png')"
        src="/assets/data_icon/icon_img.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- PDF -->
      <img v-else-if="data?.file.includes('pdf')"
        src="/assets/data_icon/icon_pdf2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- JSON -->
      <img v-else-if="data?.file.includes('json')"
        src="/assets/data_icon/icon_json2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- unknown -->
      <img v-else
        src="/assets/data_icon/icon_unknown.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
    </div>
    <!-- category 별 분류 -->
    <div v-else-if="data?.category" class="d-flex align-center">
      <!-- file -->
      <div v-if="data?.category === 'file' && data?.file" class="d-flex align-center">
        <!-- Excel -->
        <img v-if="data?.file.includes('xls') || data?.file.includes('csv')"
          src="/assets/data_icon/icon_excel.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- Image -->
        <img v-else-if="data?.file.includes('jpg') || data?.file.includes('jpeg') || data?.file.includes('png')"
          src="/assets/data_icon/icon_img.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- PDF -->
        <img v-else-if="data?.file.includes('pdf')"
          src="/assets/data_icon/icon_pdf2.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- JSON -->
        <img v-else-if="data?.file.includes('json')"
          src="/assets/data_icon/icon_json2.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- unknown -->
        <img v-else
          src="/assets/data_icon/icon_unknown.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
      </div>
      <!-- RPA -->
      <img v-else-if="data?.category === 'rpa'"
        src="/assets/data_icon/icon_rpa2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- master -->
      <img v-else-if="data?.category === 'master'"
        src="/assets/data_icon/icon_master.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Re:D -->
      <img v-else
        src="/assets/data_icon/icon_recolumn2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
    </div>
    <!-- RPA -->
    <img v-else-if="data?.data_type === 'result_file'"
      src="/assets/data_icon/icon_rpa2.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
    <!-- Re:D -->
    <img v-else
      src="/assets/data_icon/icon_recolumn2.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >

    <!-- showErrorDot (표 검출 메뉴에서 표시) -->
    <div v-if="showErrorDot" class="d-flex align-center justify-center"
      style="position: absolute; right: -5px; bottom: -5px; width: 18px; height: 18px; border-radius: 999px; background-color: #ffffff"
    >
      <v-icon style="font-size: 14px; color: #FF0000">
        mdi-alert-circle
      </v-icon>
    </div>
    <!-- 즐겨찾기 표시 -->
    <img v-else-if="showFavorite && favorite"
      src="/assets/favorite-small.svg"
      style="position: absolute; right: 1px; bottom: 1px"
      :style="{width: `calc(${iconWidth}/2)`, height: `calc(${iconHeight}/2)`}"
    >
  </div>
</template>

<script>
export default {
  name: "DataIcon",

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    iconWidth: {
      type: String,
      default: '26px'
    },
    iconHeight: {
      type: String,
      default: '26px'
    },
    showFavorite: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Number,
      default: 0
    },
    showErrorDot: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped>
</style>